import { TipoFiltro } from "../common/enumModel";
import { IFilterSolicitudModel } from "../interfaces/solicitud/IFilterSolicitudModel";

export class FilterSolicitudModel implements IFilterSolicitudModel {    
    codigo: string;
    contratista: string;
    estado: number;
    estados: number[];
    sedes: number[];
    nombreSede: string;
    fechaInicio?: Date;
    fechaFin?: Date;
    page: number;
    pageSize: number;
    solicitante: string;
    trabajo: string;
    idTipoFiltro: TipoFiltro;
    idCompania: number;

    constructor(){
        this.codigo = '';
        this.contratista = '';
        this.estado = 0;
        this.estados = [];
        this.sedes = [];
        this.nombreSede = '';
        //this.fechaInicio = null;//new Date();
        //this.fechaFin = null;//new Date();
        this.page = 1;
        this.pageSize = 30;
        this.solicitante = '';
        this.trabajo = '';
        this.idTipoFiltro = TipoFiltro.MIS_SOLICITUDES;
        this.idCompania = 0;
    }
}